module.exports = __webpack_public_path__ + "static/img/9.79a034c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/9/sp/9.png
// module id = 76tU
// module chunks = 0